import { EInHomeProductCategory, ProductCategory } from 'api/types/product';

export const getProductCategory = ({
  category,
}: {
  category: ProductCategory | EInHomeProductCategory;
}) => {
  if (category === EInHomeProductCategory.IH_WITH_DATE) {
    return ProductCategory.IH;
  } else if (category === EInHomeProductCategory.IH_WITHOUT_DATE) {
    return ProductCategory.IH;
  }

  return category;
};
